import { useState, useEffect } from 'react';

/**
 * Loads a URL into an Image element and returns its intrinsic pixel dimensions.
 * Returns { width: null, height: null } until the image has loaded.
 *
 * @param {string|null} src
 * @returns {{ width: number|null, height: number|null }}
 */
export function useImageNaturalSize( src ) {
	const [ size, setSize ] = useState( { width: null, height: null } );

	useEffect( () => {
		if ( ! src ) {
			setSize( { width: null, height: null } );
			return;
		}

		let cancelled = false;
		const img = new window.Image();

		img.onload = () => {
			if ( ! cancelled ) {
				setSize( { width: img.naturalWidth, height: img.naturalHeight } );
			}
		};
		img.onerror = () => {
			if ( ! cancelled ) {
				setSize( { width: null, height: null } );
			}
		};
		img.src = src;

		return () => {
			cancelled = true;
			img.onload  = null;
			img.onerror = null;
		};
	}, [ src ] );

	return size;
}
